import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const NotFound404: React.FC = () => {
  const navigate = useNavigate();
  const token = useSelector((state: any) => state.auth.accessToken);
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="60vh">
      <Typography variant="h2" color="error" gutterBottom>
        404 - Page Not Found
      </Typography>
      <Typography variant="body1" color="textSecondary" gutterBottom>
        The page you are looking for does not exist.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => {
        if (token) {
          navigate('/home');
        } else {
          navigate('/');
        }
      }}>Go to Home</Button>
    </Box>
  );
};

export default NotFound404;
